import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { SharedService } from '../Services/shared.service';
import { SIDENAVA_META, LAST_SELECTED_OPTION } from '../../../lib/constants/proj.cnst';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnDestroy {
  private subscription: Subscription;
  @Input() selectedSection:string = '';
  menus = SIDENAVA_META;

  constructor(private sharedservice:SharedService){
    const lastSelectedOption = localStorage.getItem(LAST_SELECTED_OPTION);
    // If a last selected option is found, set it as the default selected option
    if (lastSelectedOption) {
      this.selectedSection = lastSelectedOption;
    } 
    this.subscription = this.sharedservice.setLastSelectedSideNavOption$.subscribe((option:string) => {
      this.selectedSection = option;
    })
  }
// setting the value for Selection option (used in sideNav-content component);
  selectOption(option: string) {
    this.sharedservice.setSidenavContentlistOption('default',false)
    if(option != this.selectedSection){
      this.sharedservice.setSelectedOption(option,true);
      this.selectedSection = option;
      this.sharedservice.setSelectedOptionAsLastedSelected(option);
    } else{
      this.sharedservice.setSelectedOption('default',false);
      this.selectedSection = '';
    }
  }

  ngOnDestroy(): void {
    localStorage.removeItem(LAST_SELECTED_OPTION);
    this.subscription.unsubscribe();
  }
}
